import React from 'react'
import { NavBar } from '../components/navBar'
import { Resources } from '../components/resources'
import { ResourceCards } from '../components/resourceCards'
import './screenOverRideStyles/resourceboard.css'
export const ResourceBoard = () => {
  return (
    <div className='resourceboard'>
      <NavBar />
      <Resources />
      <ResourceCards />
    </div>
  )
}
